import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import logo from "@/assets/glassly-logo.svg";
import { GetAppButton } from "./get-app-button";

/** Public page frame: brand header with the install call to action, content column, footer. */
export function StoreShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh bg-[#f5f6f4] text-[#14151b]">
      <header className="sticky top-0 z-10 border-b border-[#e4e6e2] bg-white/88 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between gap-3 px-4 sm:px-6">
          <Link to="/" className="flex min-w-0 items-center gap-3">
            <img src={logo} alt="" className="h-[22px] w-[41px] shrink-0" />
            <span className="truncate font-display text-[15px] font-bold leading-5">Glassly Miniapp Store</span>
          </Link>
          <GetAppButton size="sm" compact />
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6">{children}</main>
      <footer className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-3 px-4 py-8 text-xs text-[#8a8d95] sm:px-6">
        <span>Miniapps install from the Glassly App on your phone.</span>
        <nav className="flex gap-4">
          <a href="https://glassly.ai" className="hover:text-[#14151b]">
            glassly.ai
          </a>
          <a href="https://docs.glassly.ai" className="hover:text-[#14151b]">
            Docs
          </a>
          <a href="https://console.glassly.ai" className="hover:text-[#14151b]">
            Publish a miniapp
          </a>
        </nav>
      </footer>
    </div>
  );
}
